import Breakpoint from "./breakpoint";
import Swiper from 'swiper';
import 'swiper/css';

export default el => {
	const filters = el.querySelectorAll('.js-filter');
	const slider = el.querySelector('.js-filter-slider');

	filters.forEach(filter => {
		filter.addEventListener('change', () => {
			update();
		})
	})

	const update = () => {
		const checkedFilters = el.querySelectorAll('.js-filter:checked');

		if (checkedFilters.length == filters.length || checkedFilters.length == 0) {
			filters.forEach(filter => {
				filter.classList.remove('inactive');
			})

			return;
		}

		filters.forEach(filter => {
			filter.classList[!filter.checked ? 'add' : 'remove']('inactive');
		})
	}

	const breakpoint =  new Breakpoint(1024);

	var swiper;
	breakpoint.under = () => {
		// slider
		const args = {
		    slidesPerView: 2.1,
		    freeMode: true,
		    spaceBetween: 10,
		    grabCursor: true,
		    breakpoints: {
		      1025: {
		        slidesPerView: el.dataset.sliderPerViewLg ? el.dataset.sliderPerViewLg : 2.5,
		      },
		  }
		}

		swiper = new Swiper(slider, args);
	}

	breakpoint.above = () => {
		if (swiper) {
			swiper.destroy();
		}
	}
};